import { Typography } from '@mui/material'
import PropTypes from 'prop-types'

const Title = (props) => {
  const { actions, children } = props
  return children ? (
    <Typography
      variant="h1"
      gutterBottom
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '0.5rem',
        '& .title': {
          flexGrow: 1,
          position: 'relative',
          zIndex: 1,
        },
        '& .title .block': {
          backgroundColor: (theme) => theme.palette.background.default,
          display: 'inline',
          paddingRight: '0.5rem',
        },
        '& .title .block:after': {
          content: '""',
          position: 'absolute',
          display: 'block',
          borderBottom: (theme) => `1px dotted ${theme.palette.primary.main}`,
          bottom: '3px',
          right: '6px',
          left: '50px',
          zIndex: -1,
        },
      }}
    >
      <span className="title">
        <span className="block">{children}</span>
      </span>
      {actions && <span className="actions">{actions}</span>}
    </Typography>
  ) : null
}

Title.propTypes = {
  actions: PropTypes.node,
}

export default Title
